module.exports = __webpack_public_path__ + "static/media/picturetopeople.org-ee389cd7bccbc0772fe2f767507baceff7820d2916f876759d.bc1b487f.png";